import React from "react"
import GridContainer from "../../../../components/layouts/containers/GridContainer.container"
import GridItem from "../../../../components/layouts/containers/GridItem.container"
import { Skeleton } from "../../../../components/atoms/misc/Skeleton.atom"
import ProjectCard from "../components/ProjectCard.molecule"
import { useSession } from "../../../../hooks/auth/useSession.hook"
import { useNavigate } from "react-router-dom"
import { AppRoutes } from "../../../../consts/appRoutes.consts"
import PrimaryButton from "../../../../components/molecules/buttons/PrimaryButton.molecule"

const ClientProjects = ({ client, teamMembers, loading }) => {
  return (
    <>
      <ClientProjectsHeader client={client} />
      <ClientProjectsGrid
        client={client}
        teamMembers={teamMembers}
        loading={loading}
      />
    </>
  )
}

const ClientProjectsHeader = ({ client }) => {
  const { user } = useSession()
  const navigate = useNavigate()
  return (
    <div className="flex align-items-center justify-content-between w-full mb-3">
      <h2 className="font-cairo font-semibold text-3xl">Proyectos</h2>
      {user.isAdmin() && client ?
        <PrimaryButton
          label="Agregar proyecto"
          icon="pi pi-plus"
          onClick={() => {
            navigate(AppRoutes.clientes.crearProyecto, {
              state: {
                client,
                isCreate: true,
              },
            })
          }}
          btnType="outlined"
        />
      : null}
    </div>
  )
}

const ClientProjectsGrid = ({ client, teamMembers, loading }) => {
  const { user } = useSession()
  const navigate = useNavigate()
  if (loading) {
    return (
      <GridContainer className="project-items-container">
        {Array.from({ length: 3 }, (_, index) => (
          <GridItem key={index} col={12} md={6} lg={4}>
            <Skeleton className="h-7rem p-0" />
          </GridItem>
        ))}
      </GridContainer>
    )
  }
  if (client?.projects?.length === 0) {
    return (
      <div className="custom-empty-message flex justify-content-center align-items-center h-full w-full">
        <div className="flex flex-column gap-2 align-items-center justify-content-center max-w-25rem m-auto text-center">
          <i className="pi pi-folder-open text-xl" />
          <span className="text-xl font-semibold font-cairo">
            Primero lo primero
          </span>
          <span>Cuando agregues proyectos, se mostrarán aquí.</span>
        </div>
      </div>
    )
  }
  return (
    <GridContainer className="project-items-container">
      {client?.projects?.map((project) => (
        <GridItem key={project.id} col={12} md={6} lg={4}>
          <ProjectCard
            project={project}
            client={client}
            teamMembers={teamMembers}
            disabled={
              (!user?.isAdmin() &&
                !(
                  user.isTeamLeader() &&
                  user.leaderProjects.includes(project.id)
                )) ||
              client.active === 0
            }
            onClick={() => {
              setTimeout(() => {
                navigate(AppRoutes.clientes.editarProyecto, {
                  state: {
                    client,
                    project,
                    isCreate: false,
                  },
                })
              }, 250)
            }}
          />
        </GridItem>
      ))}
    </GridContainer>
  )
}

export default ClientProjects
